export var createMouseHandler = function (callback) { return function (e) {
    var _a;
    // prevent mouse events to avoid losing focus from the input
    e.preventDefault();
    var index = +((_a = e.detail.mouseTarget) !== null && _a !== void 0 ? _a : '-1');
    index > -1 && callback(index);
}; };
